import { Fragment } from "react/jsx-runtime";
import Content from "../../../../components/Content/Content";
import ContentHeader from "../../../../components/ContentHeader/ContentHeader";
import ContentWrapper from "../../../../components/ContentWrapper/ContentWrapper";
import ContentFooter from "../../../../components/ContentFooter/ContentFooter";
import { useDispatch, useSelector } from "react-redux";
import { nextStep, prevStep } from "../../../../redux/slices/projectDetailsSlice";
import { RootState } from "../../../../redux/store";
import SlideContentHeader from "../SlideContentHeader/SlideContentHeader";
import SlideContentWrapper from "../SlideContentWrapper/SlideContentWrapper";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";

export default function ResponsiveDesign({ loading }: Readonly<{ loading: boolean }>) {
    const dispatch = useDispatch();
    const { selectedProject, projectSlides } = useSelector((state: RootState) => state.projectDetails);
    const slideContents = projectSlides?.map((slide) => slide.contents)?.flat()?.slice(3, 7);

    const handleNextStep = () => {
        dispatch(nextStep())
    }

    const handlePreviousStep = () => {
        dispatch(prevStep())
    }

    let slideContentClass = '';
    if (slideContents.length === 3) {
        slideContentClass = 'three-contents';
    } else if (slideContents.length >= 4) {
        slideContentClass = 'four-contents';
    }
    return (
        <ContentWrapper>
            <Fragment>
                <ContentHeader
                    title={"Project Details"}
                    subTitle={`Projects / ${selectedProject?.p_name}`}
                    handleBack={handlePreviousStep}
                />
                <Content>
                    {
                        loading ? <LoadingSpinner /> : (
                            <div className={`slide-content-wrapper ${slideContentClass}`}>
                                <></>
                                {
                                    slideContents?.map((content) => (
                                        <SlideContentWrapper key={content.title}>
                                            <SlideContentHeader>{content.title}</SlideContentHeader>
                                            <div className="slide-contents" dangerouslySetInnerHTML={{ __html: content.description }}></div>
                                        </SlideContentWrapper>
                                    ))
                                }
                            </div>
                        )
                    }

                </Content>
                <ContentFooter
                    primaryAction={{
                        label: "Next",
                        onClick: handleNextStep
                    }}
                    secondaryAction={{
                        label: "Back",
                        onClick: handlePreviousStep
                    }}
                />
            </Fragment>
        </ContentWrapper>
    )
}